import { render, staticRenderFns } from "./save-pictogram.vue?vue&type=template&id=2a1a366c"
import script from "./save-pictogram.vue?vue&type=script&lang=js"
export * from "./save-pictogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports